<template>
    <ChinaMap></ChinaMap>
</template>

<script>
import ChinaMap from "@/components/map.vue"

export default {
  name: 'MapView',
  components: {
    ChinaMap,


  },
  data(){
    return{
      // allprovincesData:[],
      // nationData:[],
      // currentIndex: 0,
      // timer:null
    }
  },
  mounted(){
    // this.getprovice()
  },
  methods:{
    // getprovice(){
    //   this.$axios.get('/api/getprovinces').then(res=>{
		// 		console.log(res.data);
    //     this.allprovincesData=res.data

    //     this.nationData=this.allprovincesData.map(item=>{
    //       return{
    //         time:item.time,
    //         area:item.area,
    //         yield:item.yield
    //       }
    //     })
    //     console.log(this.nationData)
		// 	})
    // },
    // startAutoPlay(){
    //     let that=this
    //      this.timer = setInterval(() => {
    //       this.currentIndex=(this.currentIndex+1)%this.allprovincesData.length
    //     }, 1500); // 每2秒切换一次，可根据需求调整时间间隔
    //   }
  }
}
</script>


<style>
.mapmap{
    /* height: 100%;
  width: 100%; */
}
.continer{
  display: flex;
  height: 100%;
  width: 100%;
}

</style>